export enum RoutesEnum {
  //Project Preview
  ORG_GET_PREVIEW_DATA = "iframe/project-details/{project_slug}",
  ORG_GET_LAW_DATA = "iframe/project-law-text/list",
  ORG_GET_ALLOWED_SITES = "iframe/get-allowed-sites/{project_slug}",
  ORG_GET_CITATION_DATA = "iframe/project-citation-text/list",
}
